// export const API_URL = 'https://biglot-backend.pea-cpo.com/api/v1';
// export const API_URL = 'https://pea3-chargingnetwork.com/biglot-api/api/v1';
// for build 
export const API_URL = 'https://biglotadmin.pea.co.th/biglot-api/api/v1';

// for local use 
// export const API_URL = 'https://volta-webapp.pea.co.th/biglotadmin/biglot-api/api/v1';

// Biglot User build V3.0 June 25th.zip

export function generateRandomPassword(length) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let password = "";
    
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset.charAt(randomIndex);
    }
    
    return password;
}